import { APP_VERSION } from "../versions/app-version";

import { storageLangName } from "../localization/const";

export default function ({ $axios, store }, inject) {
  $axios.defaults.timeout = 30000;

  $axios.onRequest((config) => {
    // localStorage may throw in restricted WebViews (e.g. the mobile app's
    // in-app browser for /payments/select) — don't let that break every request.
    let lang = null;
    try {
      lang = localStorage.getItem(storageLangName);
    } catch (e) {
      // ignore — restricted WebView, no localStorage access
    }
    if (lang) config.headers.common["Accept-Language"] = lang;

    if (store.getters['system/getCaptchaHeader']) {
      config.headers.common["daichi-validation-token"] = store.getters['system/getCaptchaHeader'];
    }

    // Иначе в nuxt.config генерируется на сервере один раз при build
    config.headers.common.utcOffset = new Date().getTimezoneOffset() * -1;
  });

  const ax = $axios.create({
    baseURL: process.env.API_URL,
    headers: {
      common: {
        appVersion: APP_VERSION,
        platform: "Web",
      },
    },
  });

  inject("ax", ax);
}
